// One file per module; each exports its tours (landing tab first, then one
// per tab). See defineTour.js for the shape.
import huddle from './huddle';
import inbox from './inbox';
import contacts from './contacts';
import helpdesk from './helpdesk';
import compliance from './compliance';
import voice from './voice';
import knowledgesystem from './knowledge_system';
import csat from './csat';
import crm from './crm';
import projects from './projects';
import calendar from './calendar';
import appointments from './appointments';
import marketing from './marketing';
import loyalty from './loyalty';
import socialmedia from './social_media';
import sentiment from './sentiment';
import nexus from './nexus';
import monitoring from './monitoring';
import settings from './settings';
import email from './email';
import appstore from './app_store';

const moduleTours = [
  ...huddle,
  ...inbox,
  ...contacts,
  ...helpdesk,
  ...compliance,
  ...voice,
  ...knowledgesystem,
  ...csat,
  ...crm,
  ...projects,
  ...calendar,
  ...appointments,
  ...marketing,
  ...loyalty,
  ...socialmedia,
  ...sentiment,
  ...nexus,
  ...monitoring,
  ...settings,
  ...email,
  ...appstore,
];

export default moduleTours;
